var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-row"},[_c('iframe',{staticStyle:{"width":"100%","border":"none","padding":"0 5px"},attrs:{"src":_vm.pageSrc,"height":"1000"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }